import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import BlueButton from "../../../Custom UI/Buttons/BlueButton/BlueButton";
import LabeledErrors from "../../../Custom UI/LabeledInputs/LabeledErrors/LabeledErrors";
import i18next from "i18next";
import {Translation} from "react-i18next";
import SurveyResponseCell from "../../SurveyResponseCell/SurveyResponseCell";
import {errorMessageFromServerError} from "../../../Helpers/Helpers";
import SurveyModal from "../../../Modals/SurveyModal/SurveyModal";

export default class SurveyChildSurveyQuestionCell extends React.Component{
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      menuAnchorElement:null,
      totalLoopableEntries:0,
      selectedSurveyResponse:null,
      surveyResponseToDelete:null,
      completedLoopableEntries:0,
      childSurveyResponsesArray:[],
      errors:''
    };
    if(props.question){
      this.getLoopableSurveyResponses(20, true);
    }
    this.closeMenu = this.closeMenu.bind(this);
    this.finishChildSurvey = this.finishChildSurvey.bind(this);
    this.createChildSurveyResponse = this.createChildSurveyResponse.bind(this);
    this.deleteChildSurveyResponse = this.deleteChildSurveyResponse.bind(this);
    this.getLoopableSurveyResponse = this.getLoopableSurveyResponse.bind(this);
    this.getLoopableSurveyResponses = this.getLoopableSurveyResponses.bind(this);
  }
  
  // Methods
  
  closeMenu(){
    this.setState({menuAnchorElement:null, selectedSurveyResponse:null, surveyResponseToDelete:null});
  }
  
  finishChildSurvey(){
    this.getLoopableSurveyResponse();
    this.setState({selectedSurveyResponse:null});
  }
  
  setError(aError){
    const {onError} = this.props;
    const error = typeof aError === 'string' ? aError : errorMessageFromServerError(aError);

    this.setState({errors:error});
    
    if(onError){
      onError(error);
    }
  }

  getLoopableSurveyResponse(){
    const {userId, question, isTestResponse, surveyResponseId, loopableSurveyResponse} = this.props;
    const {selectedSurveyResponse} = this.state;

    if(!question || !question.key || !selectedSurveyResponse || !selectedSurveyResponse.child_survey_response_id){
      return;
    }

    loopableSurveyResponse(userId, surveyResponseId, question.key, isTestResponse, selectedSurveyResponse.child_survey_response_id).then((newResult) => {
      const {childSurveyResponsesArray} = this.state;
      const surveyResponse = newResult.data.data.loop_survey_response;
      const total = surveyResponse.total;
      const completedLoopableEntries = surveyResponse.completed_loopable_entries;
      
      for(let index = 0; index < childSurveyResponsesArray.length; index += 1){
        let loopableSurveyResponse = childSurveyResponsesArray[index];
        
        if(loopableSurveyResponse.child_survey_response_id === surveyResponse.child_survey_response_id){
          childSurveyResponsesArray[index] = surveyResponse;
          break
        }
      }
      this.setState({totalLoopableEntries:total, completedLoopableEntries:completedLoopableEntries, childSurveyResponsesArray:[...childSurveyResponsesArray]});
    }, (newError) => {
      this.setError(newError);
    });
  }
  
  getLoopableSurveyResponses(aLimit = 20, aReload = false){
    const {userId, question, isTestResponse, surveyResponseId, loopableSurveyResponses} = this.props;
    const {totalLoopableEntries, childSurveyResponsesArray} = this.state;

    if(!question || !question.key){
      return;
    }

    if(aReload || totalLoopableEntries > childSurveyResponsesArray.length){
      loopableSurveyResponses(userId, surveyResponseId, question.key, isTestResponse, aLimit, aReload ? 0 : childSurveyResponsesArray.length).then((newResult) => {
        const total = newResult.data.data.loop_survey_responses.total;
        const completedLoopableEntries = newResult.data.data.loop_survey_responses.completed_loopable_entries;
        const newChildSurveyResponsesArray = newResult.data.data.loop_survey_responses.array;
        const originalChildSurveyResponsesArray = aReload ? [] : [...childSurveyResponsesArray];
        
        this.setState({
          totalLoopableEntries:total,
          completedLoopableEntries:completedLoopableEntries,
          childSurveyResponsesArray:[...originalChildSurveyResponsesArray, ...newChildSurveyResponsesArray]
        });
      }, (newError) => {
        this.setError(newError);
      });
    }
  }
  
  createChildSurveyResponse(){
    const {userId, question, isTestResponse, surveyResponseId, createLoopableSurveyResponse} = this.props;

    if(!question || !question.key){
      return;
    }

    createLoopableSurveyResponse(userId, surveyResponseId, question.key, isTestResponse).then((newResult) => {
      const {childSurveyResponsesArray} = this.state;
      const surveyResponse = newResult.data.data.createLoopSurveyResponse;
      const total = surveyResponse.total;
      const completedLoopableEntries = surveyResponse.completed_loopable_entries;
      childSurveyResponsesArray.push(surveyResponse)
      this.setState({totalLoopableEntries:total, completedLoopableEntries:completedLoopableEntries, selectedSurveyResponse:surveyResponse, childSurveyResponsesArray:[...childSurveyResponsesArray]});
    }, (newError) => {
      this.setError(newError);
    });
  }
  
  deleteChildSurveyResponse(aChildSurveyResponse){
    const {userId, isTestResponse, surveyResponseId, deleteLoopableSurveyResponse} = this.props;
    // export function deleteLoopableSurveyResponse(aPatientId, aSurveyResponseId, aChildSurveyResponseId = null, aIsTestResponse = false, aLoopReference = null, aIndex = null){

    if(!aChildSurveyResponse || !aChildSurveyResponse.child_survey_response_id){
      return;
    }

    deleteLoopableSurveyResponse(userId, surveyResponseId, aChildSurveyResponse.child_survey_response_id, isTestResponse).then((newResult) => {
      const {childSurveyResponsesArray} = this.state;
      const deletedSurveyResponse = newResult.data.data.deleteLoopSurveyResponse;
      const total = deletedSurveyResponse.total;
      const completedLoopableEntries = deletedSurveyResponse.completed_loopable_entries;
      
      for(let index = 0; index < childSurveyResponsesArray.length; index += 1){
        let loopableSurveyResponse = childSurveyResponsesArray[index];
        
        if(loopableSurveyResponse.child_survey_response_id === aChildSurveyResponse.child_survey_response_id){
          childSurveyResponsesArray.splice(index, 1);
          break
        }
      }
      this.setState({totalLoopableEntries:total, completedLoopableEntries:completedLoopableEntries, childSurveyResponsesArray:[...childSurveyResponsesArray]});
    }, (newError) => {
      this.setError(newError);
    });
  }
  
  // Render
  
  render(){
    const {menuAnchorElement, selectedSurveyResponse, surveyResponseToDelete, childSurveyResponsesArray, errors} = this.state;
    const {userId, adminId, company, patient, user, createDataQueryNote, disabled, question, addDataQuery, isTestResponse} = this.props;
    const {key, child_survey_id} = question;
    const selectedChildSurveyResponseId = selectedSurveyResponse && selectedSurveyResponse.child_survey_response ? selectedSurveyResponse.child_survey_response.id : selectedSurveyResponse && selectedSurveyResponse.child_survey_response_id ? selectedSurveyResponse.child_survey_response_id : null;
    const childSurveyNotFound = !child_survey_id;
    const childSurveyErrorMessage = errors || (childSurveyNotFound ? i18next.t('CHILD_SURVEY_NOT_FOUND') : '');
    
    return(
      <div className="survey-skip-cell"
           key={'survey-child-survey-question-cell-' + key}>
        <LabeledErrors errorMessage={childSurveyErrorMessage} />

        {(childSurveyResponsesArray && childSurveyResponsesArray.map((surveyResponse, index) => {
          const childSurveyResponseId = surveyResponse.child_survey_response_id || (surveyResponse.child_survey_response ? surveyResponse.child_survey_response.id : null);

          return (
            <SurveyResponseCell key={'child-' + childSurveyResponseId + '-' + index}
                                onClick={() => this.setState({selectedSurveyResponse:surveyResponse})}
                                surveyResponse={surveyResponse.child_survey_response}
                                menuButtonClicked={(aEvent) => this.setState({menuAnchorElement:aEvent.currentTarget, surveyResponseToDelete:surveyResponse})}
            />
          )}))}
        
        {!childSurveyNotFound ?
          <BlueButton className="add-button"
                      name={<Translation>{(t, {i18n}) => t('ADD_ANOTHER')}</Translation>}
                      onClick={() => this.createChildSurveyResponse()}
                      disabled={disabled}
          />
          :
          null
        }
        
        <SurveyModal open={selectedSurveyResponse !== null}
                     finish={() => this.finishChildSurvey()}
                     userId={userId}
                     adminId={adminId}
                     company={company}
                     editable={!disabled}
                     surveyId={child_survey_id}
                     addDataQuery={addDataQuery ? (aSurveyResponseDetailsId, aSurveyResponseId) => addDataQuery(aSurveyResponseDetailsId, aSurveyResponseId) : null}
                     patient={patient}
                     user={user}
                     createDataQueryNote={createDataQueryNote}
                     isTestResponse={isTestResponse}
                     surveyResponseId={selectedChildSurveyResponseId}
        />
        
        <Menu id="child-survey-responses-menu"
              open={Boolean(menuAnchorElement)}
              style={{zIndex:99999}}
              onClose={() => this.closeMenu()}
              anchorEl={menuAnchorElement}
              keepMounted>
          <MenuItem style={{position:'relative'}}
                    onClick={() => {
                      this.deleteChildSurveyResponse(surveyResponseToDelete);
                      this.closeMenu();
                    }}>
            <Translation>{ (t, { i18n }) => t('DELETE')}</Translation>
          </MenuItem>
        </Menu>
      </div>
    )
  }
}
